module.exports = __webpack_public_path__ + "/images/logo-fr-larmoire-de-bebe.89c059a.png";